import { c as _c } from "react/compiler-runtime";
import { CENTERED_LAYOUT_BASE_CLASSNAME, DesignProvider, LAYOUT_BASE_CLASSNAME, LocaleProvider, useDesignContext } from '@systemeio/digital-store-shared';
import { LocaleEnum } from '@systemeio/ui';
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import React, { FC, Fragment } from 'react';
import Frame, { FrameContextConsumer } from 'react-frame-component';
import { Loader } from 'shared/components/loader';
import { twMerge } from 'tailwind-merge';
const HIDE_SCROLLBAR_CSS = 'html{-ms-overflow-style:none;scrollbar-width:none;}html::-webkit-scrollbar{display:none;}';
const PreviewBox: FC = () => {
  const $ = _c(6);
  const {
    preview,
    singleItemMode,
    css
  } = useStorePreviewContext();
  const {
    storeId
  } = useStoreQuery();
  const {
    data: storeView
  } = useStore(storeId);
  const {
    state
  } = useDesignContext();
  const initialContent = `<!DOCTYPE html><html><head><style>${css}${HIDE_SCROLLBAR_CSS}</style></head><body></body></html>`;
  let t0;
  if ($[0] !== initialContent || $[1] !== preview || $[2] !== singleItemMode || $[3] !== state || $[4] !== storeView?.locale) {
    t0 = <div className="noScrollbar sliderScroll h-full max-h-[720px] w-[360px] overflow-y-auto overflow-x-hidden rounded-[30px] border-[5px] border-black lg:shrink-0">{!!preview.length ? <Frame mountTarget="body" initialContent={initialContent} width="100%" height="100%" tabIndex={-1}><FrameContextConsumer>{t1 => {
            const {
              document
            } = t1;
            return <LocaleProvider locale={storeView?.locale ?? LocaleEnum.ENGLISH}><DesignProvider design={state} customRoot={document}><div className={twMerge(singleItemMode ? CENTERED_LAYOUT_BASE_CLASSNAME : LAYOUT_BASE_CLASSNAME)} style={{
                  pointerEvents: "none"
                }} inert="">{preview.map(_temp)}</div></DesignProvider></LocaleProvider>;
          }}</FrameContextConsumer></Frame> : <div className="flex h-full items-center justify-center"><Loader type="dark" /></div>}</div>;
    $[0] = initialContent;
    $[1] = preview;
    $[2] = singleItemMode;
    $[3] = state;
    $[4] = storeView?.locale;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
export default PreviewBox;
function _temp(item, index) {
  return <Fragment key={index}>{item}</Fragment>;
}